module.exports = __webpack_public_path__ + "assets/images/img_temperature-humidity-side-illustration.png";